exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-item[data-v-246fb88f] .el-form-item{margin-bottom:5px}\n", ""]);

// exports
